import { render, staticRenderFns } from "./Shipper.vue?vue&type=template&id=de0ec282"
import script from "./Shipper.vue?vue&type=script&lang=js"
export * from "./Shipper.vue?vue&type=script&lang=js"
import style0 from "./Shipper.vue?vue&type=style&index=0&id=de0ec282&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports